import * as React from "react";
import { observer } from "mobx-react";
import { Renderer } from "../Renderer";
import { defineCustomTags } from "../../../../helpers";
defineCustomTags("sb-lazy-render");
//TODO: remove this and use component from shared library that is to be developed - https://jira.dkcorpit.com/browse/SB-24657
//same as dk-same-game-parlay blocks
class LazyRenderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.refRoot = React.createRef();
        this.state = {
            renderer: new Renderer(this.props.observerOptions || {})
        };
    }
    componentWillUnmount() {
        if (this.refRoot.current) {
            this.state.renderer.unRegisterDom(this.refRoot.current);
        }
    }
    componentDidMount() {
        if (this.refRoot.current) {
            this.state.renderer.registerDom(this.refRoot.current);
        }
    }
    getChildren() {
        return typeof this.props.contentCallback === "function"
            ? this.props.contentCallback()
            : this.props.children;
    }
    render() {
        const props = {
            style: {
                minHeight: this.props.baseMinHeight,
                display: "block",
                position: "relative",
                boxSizing: "border-box",
            },
            ref: this.refRoot,
        };
        return (React.createElement("sb-lazy-render", Object.assign({}, props, { "data-testid": "sb-lazy-render" }), this.state.renderer.isVisible && this.getChildren()));
    }
}
export const LazyRender = observer(LazyRenderComponent);
//# sourceMappingURL=LazyRender.js.map